/**
 * for more info, visit https://www.notion.so/modernhealth/Daily-Pause-streak-tracking-92123e3478c24cd7b439460ab10900d4
 *
 * Note: as of writing 8/5/22, we have a total of 107 Daily Pauses and this implementation is MVP.
 * Milestones list should be generated from the BE, it will be done within this ticket https://joinmodernhealth.atlassian.net/browse/FDR-2157
 */

export const milestones = [1, 5, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140];

export const groupMilestones = (arr: number[], perGroup: number, groupsCount: number) => {
    return new Array(groupsCount)
        .fill('')
        .map((_, i) => arr.slice(i * (perGroup - 1), (i + 1) * perGroup).slice(0, perGroup));
};

export const findClosestMilestone = (arr: number[], completedCount: number) =>
    arr.reduce((prev, curr) => {
        return Math.abs(curr - completedCount) < Math.abs(prev - completedCount) &&
            curr <= completedCount
            ? curr
            : prev;
    });
